import { Link } from "react-router-dom";
import { ShoppingBag } from "lucide-react";
import Layout from "@/components/layout/Layout";
import Bag from "@/components/cart/Bag";
import { useCart } from "@/context/CartContext";

const money = (n) => `$${(Number(n) || 0).toFixed(2)}`;

/** Your items from one shop. Each shop is checked out and paid separately. */
export default function Bags() {
    const { bags, removeItem, subtotal } = useCart();

    return (
        <Layout hideTicker>
            <div className="mx-auto max-w-6xl px-4 py-12 sm:px-6">
                <p className="font-mono text-[11px] uppercase tracking-[0.32em] text-zinc-500">Checkout</p>
                <h1 className="mt-3 flex items-center gap-3 font-display text-3xl font-black tracking-tight sm:text-4xl" data-testid="bags-title">
                    <ShoppingBag /> Your cart
                </h1>

                {bags.length === 0 ? (
                    <div className="mt-10 rounded-3xl border border-dashed border-white/15 px-6 py-20 text-center" data-testid="bags-empty">
                        <ShoppingBag size={40} className="mx-auto text-zinc-700" />
                        <p className="mt-5 font-display text-xl font-bold">Your cart is empty.</p>
                        <p className="mt-2 text-zinc-400">Browse a shop and add something.</p>
                        <Link to="/directory" className="mt-6 inline-flex items-center gap-2 rounded-full bg-white px-6 py-3 text-sm font-bold uppercase tracking-wide text-black transition-transform hover:scale-[1.03]"
                            data-testid="bags-walk-cta">
                            Browse shops
                        </Link>
                    </div>
                ) : (
                    <>
                        {bags.length > 1 && (
                            <p className="mt-3 max-w-2xl text-zinc-400" data-testid="bags-multi-shop-note">
                                Your items come from {bags.length} different shops. Each shop is paid separately — pick one below to check out,
                                and the others stay in your cart.
                            </p>
                        )}
                        <div className="mt-8 grid gap-5 lg:grid-cols-2" data-testid="bags-grid">
                            {bags.map((bag) => <Bag key={bag.slug} bag={bag} onRemove={removeItem} expanded />)}
                        </div>
                        <div className="mt-8 flex flex-wrap items-center justify-between gap-3 rounded-2xl border border-white/10 bg-white/[0.02] px-5 py-4">
                            <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-zinc-500">
                                {bags.length > 1 ? `Total for all ${bags.length} shops` : "Total"}
                            </p>
                            <p className="font-display text-lg font-black" data-testid="bags-total">{money(subtotal)}</p>
                        </div>
                    </>
                )}
            </div>
        </Layout>
    );
}
